import type { ReactElement } from "react";
import type { ProblemTimelineParams } from "@playbookai/widget-schemas";
import type { WidgetBodyProps } from "../types.js";
import { TimelineTrack } from "./TimelineTrack.js";
import { TimelineSummaryStrip } from "./TimelineSummary.js";
import { timelineSummary } from "./presentation.js";

export function ProblemTimelineWidget({
  data,
}: WidgetBodyProps<ProblemTimelineParams>): ReactElement {
  const result = timelineSummary(data);
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-3">
      <TimelineSummaryStrip data={data} variant="plain" />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col justify-center gap-3 border-t border-pb-border py-3">
        <p className="text-xs text-pb-text-muted">Key milestones</p>
        <TimelineTrack data={data} compact />
      </div>
      {result.issues.length > 0 ? (
        <div className="rounded-md border border-pb-red/30 bg-pb-red/10 px-2.5 py-1.5 text-dense-1 text-pb-red-text">
          {result.issues.map((issue) => (
            <div key={issue}>⚠ {issue}</div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
